import { DebitCard } from "components/WaysToPay/PaymentMethods/DebitCard/DebitCard";
import { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useEventTracking } from "react-event-tracker";
import { AutoPayment } from "./AutoPayment";
import { BankTransfer } from "./BankTransfer";
import { Bpay } from "./Bpay";
import { ByMail } from "./ByMail";
import { DirectDebit } from "./DirectDebit";
import { InPerson } from "./InPerson";
import { InternetBanking } from "./InternetBanking";
import { Other } from "./Other";
import styles from "./payment-methods.module.scss";

const Component = (
  method,
  paymentInfo,
  commonData,
  productName,
  bankTransferDetails,
  availableMethods,
  product,
  amount,
  account,
) => {
  const mapping = {
    direct_transfer: BankTransfer,
    direct_debit: DirectDebit,
    by_mail: ByMail,
    in_person: InPerson,
    internet_banking: InternetBanking,
    debit_card: DebitCard,
    bpay: Bpay,
    auto_payment: AutoPayment,
    other: Other,
  };
  const PaymentMethod = mapping[method];
  return (
    <PaymentMethod
      paymentInfo={paymentInfo}
      commonData={commonData}
      productName={productName}
      bankTransferDetails={bankTransferDetails}
      availableMethods={availableMethods}
      product={product}
      amount={amount}
      account={account}
    />
  );
};

export const PaymentMethods = ({
  product,
  pageError,
  availableMethods,
  commonData,
  account,
  productName,
  fields = {},
  amount,
}) => {
  const { trackEvent } = useEventTracking();
  const bsbError =
    pageError && pageError.includes("BSB NOT FOUND")
      ? "Please enter a valid BSB"
      : null;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [methods, setMethods] = useState([]);
  const [bankTransferState, setBankTransferState] = useState({
    eligible: false,
    bsb: fields.bsb || "",
    accountNum: fields.accountNum || "",
    bsbError: bsbError || false,
    accError: false,
  });

  useEffect(() => {
    const methodsArray =
      product.region === "NZ"
        ? availableMethods
        : availableMethods.filter(
            (item) => !(item === "in_person" || item === "by_mail"),
          );

    if (
      product.region !== "NZ" &&
      (availableMethods.includes("in_person") ||
        availableMethods.includes("by_mail"))
    ) {
      methodsArray.push("other");
    }
    setMethods(methodsArray);
  }, [availableMethods, product.region]);

  const updateBankTransferState = (newState) =>
    setBankTransferState({
      ...bankTransferState,
      ...newState,
    });

  const bankTransferDetails = { ...bankTransferState, updateBankTransferState };

  const nameMap = {
    direct_transfer: {
      msg: "Bank transfer",
      formattedMsg: (
        <>
          Bank
          <br />
          transfer
        </>
      ),
    },
    bpay: { msg: "BPAY" },
    in_person: { msg: "In person" },
    direct_debit: {
      msg: "Direct debit",
      formattedMsg: (
        <>
          Direct <br /> Debit
        </>
      ),
    },
    internet_banking: {
      msg: "Internet banking",
      formattedMsg: (
        <>
          Internet <br /> Banking
        </>
      ),
    },
    auto_payment: {
      msg: "Automatic payment",
      formattedMsg: (
        <>
          Automatic <br /> Payment
        </>
      ),
    },
    debit_card: {
      msg: "Debit card",
      formattedMsg: (
        <>
          Debit <br /> Card
        </>
      ),
    },
    by_mail: { msg: "By mail" },
    other: { msg: "Other" },
  };

  return (
    <>
      <Tabs
        className={styles.tabs}
        disabledTabClassName={styles.disabled}
        selectedTabClassName={styles.selectedTab}
        selectedTabPanelClassName={styles.selectedPanel}
        selectedIndex={selectedIndex}
        onSelect={(index) => {
          document.getElementById("payment-select").value = index;
          trackEvent({
            event: {
              event_category: "select",
              event_action: "in-page-navigation",
              event_location: "Payment method",
              label: nameMap[methods[index]].msg,
            },
          });
          setSelectedIndex(index);
        }}
      >
        <div className={styles.selectWrapper}>
          <select
            id="payment-select"
            onChange={(e) => {
              trackEvent({
                event: {
                  event_category: "select",
                  event_action: "in-page-navigation",
                  event_location: "Payment method",
                  label: nameMap[methods[e.target.value]].msg,
                },
              });
              setSelectedIndex(Number(e.target.value));
            }}
          >
            {methods.map((method, index) => (
              <option value={index} key={index}>
                {nameMap[method].msg}
              </option>
            ))}
          </select>
        </div>
        <TabList className={styles.list}>
          {methods.map((method, index) => (
            <Tab className={`${styles.tab} ${styles[method]}`} key={index}>
              {nameMap[method].msg}
            </Tab>
          ))}
        </TabList>
        {methods.map((method, index) => (
          <TabPanel className={styles.panel} key={index}>
            {Component(
              method,
              product.payment_methods[method],
              commonData,
              productName,
              bankTransferDetails,
              availableMethods,
              product,
              amount,
              account,
            )}
          </TabPanel>
        ))}
      </Tabs>
    </>
  );
};
